<template>
  <div class="over-heigth">
    <el-card v-loading="pageLoading">
      <div slot="header" class="clearfix">
        <span>第{{ day }}天-經過點設定</span>
        <el-button style="float: right; padding: 6px 15px" type="success" @click="passPointSave"
          >儲存</el-button
        >
      </div>

      <div>
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item>
            <el-button type="success" @click="addNew">新增</el-button>
          </el-form-item>
        </el-form>

        <el-form
          v-for="(item, index) in list"
          :key="index"
          :inline="true"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="" size="mini">
            <el-tag>{{ index + 1 }}</el-tag>
          </el-form-item>
          <el-form-item label="區域" size="mini">
            <el-select
              v-if="item.regions"
              v-model="item.region"
              v-loading="pageLoading"
              value-key="key"
              placeholder="區域"
              size="mini"
              style="width: 100px"
              @change="selectedRegion(item)"
            >
              <el-option
                v-for="(c, ind) in item.regions"
                :key="ind"
                :label="c.val"
                :value="c.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="國家" size="mini">
            <el-select
              v-if="item.countries"
              v-model="item.country"
              v-loading="item.countriesLoading"
              filterable
              placeholder="國家"
              value-key="code"
              size="mini"
              style="width: 100px"
              @change="selectedCountry(item)"
            >
              <el-option
                v-for="(c, ind) in item.countries"
                :key="ind"
                :label="c.chtName"
                :value="c"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="城市" size="mini">
            <el-select
              v-if="item.cities"
              v-model="item.city"
              v-loading="item.countriesLoading || item.citiesLoading"
              clearable
              filterable
              placeholder="城市"
              value-key="code"
              size="mini"
              style="width: 120px"
              @change="selectedCity(item)"
            >
              <el-option v-for="(c, ind) in item.cities" :key="ind" :label="c.chtName" :value="c" />
            </el-select>
          </el-form-item>

          <el-form-item label="經緯度(lng,lat)" style="display: none">
            <el-col class="line" :span="12">
              <el-input v-model="item.lng" placeholder="經度(lng)" />
            </el-col>
            <el-col class="line" :span="12">
              <el-input v-model="item.lat" placeholder="緯度(lat)" />
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button type="danger" @click="deleteData(item)">刪除</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  getCountriesByRegion,
  getCitiesByCountryCode,
  saveItineraryPlanningSettingPassPorint,
  getItineraryPlanningSettingPassPorint,
} from '@/api/travel'

import { MessageBox, Message } from 'element-ui'

export default {
  name: 'PassPointCcomponents',
  components: { Pagination },
  props: {
    regions: {
      type: Array,
      default: [],
    },
    travelNum: {
      type: Number,
      default: 0,
    },
    day: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      regionsSource: this.regions,
      pageLoading: false,
      list: [],
    }
  },
  async created() {
    const vm = this
    await vm.getList()
  },
  methods: {
    async getList() {
      const vm = this
      vm.pageLoading = true
      await getItineraryPlanningSettingPassPorint({
        travelID: this.travelNum,
        day: this.day,
      }).then(response => {
        debugger
        vm.list = response.data.data
        vm.pageLoading = false
      })
    },
    passPointSave() {
      const vm = this

      let isValid = true
      const thisTimeData = []
      vm.pageLoading = true

      vm.list.forEach((element, index) => {
        const dataIndex = index + 1
        const { id, region, country, city, description, lat, lng } = element
        if (!country) {
          Message({
            message: `第${dataIndex}筆，請選擇國家。`,
            type: 'error',
            duration: 5 * 1000,
          })
          isValid = false
          return false
        }
        if (!lat || parseFloat(lat == 0) || !lng || parseFloat(lng == 0)) {
          Message({
            message: `第${dataIndex}筆，經緯度錯誤，請輸入正確經緯度。`,
            type: 'error',
            duration: 5 * 1000,
          })
          isValid = false
          return false
        }

        const p = {
          id,
          region,
          country,
          city,
          description,
          lat,
          lng,
          day: vm.day,
        }
        thisTimeData.push(p)
      })

      if (!isValid) {
        vm.pageLoading = false
        return
      }
      const payload = {
        travelID: vm.travelNum,
        day: vm.day,
        data: thisTimeData,
      }

      saveItineraryPlanningSettingPassPorint(payload).then(response => {
        vm.pageLoading = false
        Message({
          message: '行程經過點設定完成',
          type: 'success',
          duration: 5 * 1000,
        })
      })
    },
    async addNew() {
      const vm = this
      let emptyObj = {}
      const dataLen = vm.list.length
      if (dataLen > 0) {
        const copyObj = vm.list[dataLen - 1]
        emptyObj = JSON.parse(JSON.stringify(copyObj))
        emptyObj.id = null
        emptyObj.description = null
      } else {
        emptyObj = {
          regions: JSON.parse(JSON.stringify(vm.regionsSource)),
          countries: [],
          cities: [],
          lat: '',
          lng: '',
          citiesLoading: false,
          countriesLoading: false,
        }
      }

      vm.list.push(emptyObj)
    },
    async selectedRegion(data) {
      const vm = this
      data.country = null
      data.city = null
      data.countries = []
      data.cities = []
      data.countriesLoading = true
      await getCountriesByRegion({ region: data.region }).then(response => {
        data.countriesLoading = false
        data.countries = response.data
      })
    },
    async selectedCountry(data) {
      const vm = this
      data.city = null
      data.cities = []
      data.citiesLoading = true
      data.lat = data.country.lat
      data.lng = data.country.lng
      await getCitiesByCountryCode({ countryCode: data.country.code }).then(response => {
        data.citiesLoading = false
        data.cities = response.data
      })
    },
    async selectedCity(data) {
      const vm = this
      data.lat = data.city.lat
      data.lng = data.city.lng
    },
    deleteData: function (event) {
      const vm = this
      vm.list.splice(vm.list.indexOf(event), 1)
    },
  },
}
</script>

<style>
.over-heigth {
  position: relative;
  height: 100%;
}
</style>
